import { isRegion, REGIONS } from './region'

export function supportsTips(region = process.env.REACT_APP_REGION) {
  return !isRegion(region, REGIONS.TW)
}

export default {
  supportsTips,
}
